import React from "react"
import { withLocalize, Translate } from "react-localize-redux";
import Money from "../../common/moneyComponent";
import Number from "../../common/numberComponent";

class BandTable extends React.Component {
    render() {
        let bands = this.props.bands;
        return (Array.isArray(bands) && bands.length > 0) ? (
            <>
                <table className="table table-report-section small-padding">
                    <colgroup>
                        <col width="20%" />
                        <col width="20%" />
                        <col width="20%" />
                        <col width="10%" />
                        <col width="10%" />
                        <col width="10%" />
                        <col width="10%" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th rowSpan="2" ><Translate id="Report.Itrade.BandValues" data={{ currency: this.props.currency }} /></th>
                            <th rowSpan="2" className="right"><Translate id="Report.Itrade.ExperienceCount" /></th>
                            <th rowSpan="2" className="right"><Translate id="Report.Itrade.BandTotalValue" data={{ currency: this.props.currency }} /></th>
                            <th colSpan="4" className='center'><Translate id="Report.Itrade.PaymentPct" /></th>
                        </tr>
                        <tr>
                            <th className="right">1-30</th>
                            <th className="right">31-60</th>
                            <th className="right">61-90</th>
                            <th className="right">{">"} 90</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            bands.map((b, i) => {
                                return (
                                    <tr key={i}>
                                        <td>{b.range}</td>
                                        <td className="right">{b.count === 0 ? "" : <Number value={b.count} />}</td>
                                        <td className="right">{b.total !== 0 ? <Money value={b.total} fractionDigits={0} /> : ""}</td>
                                        <td className="right">{GetTableCell(b.thirty, b.total)}</td>
                                        <td className="right">{GetTableCell(b.sixty, b.total)}</td>
                                        <td className="right">{GetTableCell(b.ninety, b.total)}</td>
                                        <td className="right">{GetTableCell(b.overNinety, b.total)}</td>
                                    </tr>
                                )
                            })

                        }

                    </tbody>
                    <thead>
                        <tr style={{ fontWeight: "600" }}>
                            <th><Translate id="Report.Common.Sum" /></th>
                            <th className="right"><Number value={bands.map(b => b.count).reduce((a, b) => a + b)} /></th>
                            <th className="right"><Money value={bands.map(b => b.total).reduce((a, b) => a + b)} fractionDigits={0} /></th>
                            <th colSpan={4}></th>
                        </tr>
                    </thead>
                </table>
                <span className='hide-on-desktop underlined-title-wrapper'>
                    <span className='underlined-title'><Translate id='Report.Itrade.PaymentPct'/></span>
                </span>
            </>
        ) : null;
    }
}
const GetTableCell = (value, total) => {
    return (
        <React.Fragment>
            {total !== 0 && value !== 0 ? <Money fractionDigits={1} value={value / total * 100} /> : total !== 0 ? <Money fractionDigits={1} value={0} /> : ""}
        </React.Fragment>
    )
}

export default withLocalize(BandTable);